import React, { useState, ChangeEvent } from 'react';
import Editor from '../../editor/Editor';
import POST_QUERY from "./queries/POST_QUERY";
import { useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { Form, Button } from 'react-bootstrap';
import EDIT_POST_MUTATION from './queries/EDIT_POST_MUTATION';
import Loading from '../../common/Loading';
import AlertDismissible from '../../common/AlertDismissible';
import { removeTypename } from '../../utils';

const EditPost = () => {
    const [content, setContent] = useState('');
    const [title, setTitle] = useState('');
    const [saving, setSaving] = useState(false);
    const [success, setSuccess] = useState(false);
    const { id }:{id?: string} = useParams();
    const getEditedData = () => {
        const changed = {
            ...data?.post,
            title,
            content,
        }
        delete changed.createdAt;
        delete changed.updatedAt;
        return removeTypename(changed);
    }
    const { data, loading } = useQuery(POST_QUERY, {
        variables: { postId: id },
        onCompleted: (res) => {
            setTitle(res.post.title);
            setContent(res.post.content);
        },
    });
    const [editPost] = useMutation(EDIT_POST_MUTATION, {
        variables: {
            postData: {
                ...getEditedData()
            },
        },
        onCompleted: (res) => {
            setSaving(false);
            setSuccess(true);
        },
        refetchQueries: [
            {
                query: POST_QUERY,
                variables: { postId: id },
            }
        ]
    });
    const renderPost = () => {

        return (<Form>
            {(loading) && <div className="mt-4 mb-4"><Loading /></div>}
            {success && <AlertDismissible variant="success" dismissible onClose={() => setSuccess(false)} className="mt-4">Post Saved.</AlertDismissible>}
            {data && <Form.Group className="mt-4" id="postTitleControl">
                <Form.Label>Title</Form.Label>
                <Form.Control onChange={(event: ChangeEvent<any>) => {
                    const changed: string = event.target.value || '';
                    setTitle(changed);
                }} placeholder="Post Title" defaultValue={data?.post?.title} type="text" />
            </Form.Group>}
            {data?.post && <Editor onChange={(changedContent: string) => setContent(changedContent)} value={data.post.content} className="mt-4" />}
            <Button disabled={saving || loading} variant="primary" className="mt-4" onClick={() => { editPost(); setSaving(true) }}>Save Changes</Button>
        </Form>);
    };
    return <div>{renderPost()}</div>;
};

export default EditPost;
